import React from 'react';
import PlatformDetailPage from './PlatformDetailPage';

const BrontoYPage = () => <PlatformDetailPage platformId="brontoy" />;

export default BrontoYPage;
